export enum TokenState {
  Outdated = 'Outdated',
  New = 'New',
  Na = 'NA',
  None = 'None',
  Current = 'Current',
  Error = 'Error',
}
